import classnames from 'classnames';

export default classnames;
